import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative h-[420px] md:h-[600px] w-full overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Cinematic%20entertainment%20scene%20with%20abstract%20flowing%20film%20strips%20and%20soft%20glowing%20light%20particles%20warm%20deep%20crimson%20and%20dark%20charcoal%20background%20modern%20premium%20vibe%20elegant%20minimalist%20composition%20no%20people&width=1800&height=900&seq=hero-bg-2026&orientation=landscape"
        alt="宅男视频 - 流畅高清在线观看"
        className="absolute inset-0 w-full h-full object-cover object-top"
        title="宅男视频 · 久久视频 · 小蓝视频 · 豆花视频 高清流畅在线观看"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/30 to-black/60"></div>

      <div className="relative z-10 h-full flex flex-col items-center justify-center w-full px-4 md:px-6">
        <div className="text-center max-w-3xl">
          <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading font-bold text-white mb-4 leading-tight">
            宅男视频 · 流畅高清在线观看
          </h1>
          <p className="text-base md:text-lg text-white/80 mb-8 max-w-2xl mx-auto leading-relaxed">
            接入<strong className="text-accent-300">久久视频</strong>、<strong className="text-accent-300">小蓝视频</strong>、<strong className="text-accent-300">豆花视频</strong>等稳定平台
            <br className="hidden sm:block" />
            提供<strong className="text-accent-300">不缓冲</strong>的流畅高清观看体验，免费影视全集每日更新，久用不卡顿更顺畅
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
            <Link
              to="/category/hot"
              className="px-8 py-3.5 bg-primary-500 text-white rounded-full font-semibold text-sm whitespace-nowrap cursor-pointer hover:bg-primary-600 transition-all duration-300 inline-flex items-center gap-2"
            >
              <div className="w-5 h-5 flex items-center justify-center">
                <i className="ri-fire-line"></i>
              </div>
              热门推荐
            </Link>
            <Link
              to="/category/movie"
              className="px-8 py-3.5 bg-white/15 backdrop-blur-sm text-white border border-white/25 rounded-full font-semibold text-sm whitespace-nowrap cursor-pointer hover:bg-white/25 transition-all duration-300 inline-flex items-center gap-2"
            >
              <div className="w-5 h-5 flex items-center justify-center">
                <i className="ri-film-line"></i>
              </div>
              立即观影
            </Link>
          </div>
        </div>

        <div className="absolute bottom-6 left-1/2 -translate-x-1/2 flex items-center gap-2 text-white/60 text-xs">
          <span>向下滚动探索更多</span>
          <div className="w-4 h-4 flex items-center justify-center">
            <i className="ri-arrow-down-s-line animate-bounce"></i>
          </div>
        </div>
      </div>
    </section>
  );
}